<template>
  <div class="container">
    <Header></Header>

    <div class="banner">
      <div class="search-wrap">
        <div class="search-inner">
          <div class="search-title">
            <span v-text="$t('msg.searchTitle')"></span>
            <!-- <span class="tip" v-text="$t('msg.searchTitleTip')"></span> -->
          </div>
          <div class="search-input" :class="{'required': showRequired}">
            <img src="../assets/images/icon-search@2x.png" alt />
            <input
              type="text"
              :placeholder="$t('msg.searchInputPlaceholder')"
              v-model.trim="search"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="search-btn" @click="onSearch" v-text="$t('msg.searchBtn')"></div>
        </div>
      </div>
    </div>

    <div class="airport-wrap">
      <div class="loading" v-show="showLoading">
        <img src="../assets/images/Page-loader-123px.svg" alt />
        <p>Loading</p>
      </div>

      <div class="hasData" v-if="showAirportList && airportList.length > 0">
        <div class="num" v-text="airportTotal"></div>
        <h3 class="sort">Sort By City</h3>
        <div class="airport-list clearfix" v-for="parent in newAirportList" :key="parent.sort">
          <div class="zimu" v-text="parent.sort"></div>
          <div>
            <ul class="clearfix">
              <li
                v-for="child in parent.list"
                :key="child.code"
                @click="toTerminal(child)"
                :class="{'disable': !child.name}"
              >
                <div v-if="child.name" class="borderLeft">
                  <p class="name" v-show="child.name">
                    <span v-text="child.name"></span> -
                    <span v-text="child.iataCode"></span>
                  </p>
                  <p class="addr" v-show="child.city || child.country">
                    <span v-text="child.city"></span>,
                    <span v-text="child.country"></span>
                  </p>
                </div>
                <div v-else></div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="noData"
        v-if="showAirportList && airportList.length === 0"
        v-text="$t('msg.searchResult')"
      ></div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { setTimeout } from "timers";

export default {
  name: "airport",
  data() {
    return {
      showLoading: false,
      showAirportList: false,
      airportList: [],
      newAirportList: [],
      search: "",
      showRequired: false
    };
  },
  components: {
    Header,
    Footer
  },
  methods: {
    uniq(array) {
      var temp = []; //一个新的临时数组
      for (var i = 0; i < array.length; i++) {
        if (temp.indexOf(array[i]) == -1) {
          temp.push(array[i]);
        }
      }
      return temp;
    },
    onSearch() {
      if (this.search === "") {
        this.showRequired = true;
        return;
      } else {
        this.showAirportList = false;
        this.showLoading = true;
        this.$axios
          .get("/api/airport/search", {
            params: {
              keyword: this.search
            }
          })
          .then(res => {
            this.showLoading = false;
            this.showAirportList = true;
            this.search = "";
            if (res.data.state === "11") {
              const list = res.data.data.list;
              this.airportList = list;
              let listArr = [];
              list.forEach(el => {
                for (let i = 0; i < listArr.length; i++) {
                  if (listArr[i].sort === el.sort) {
                    listArr[i].list.push({
                      code: el.code,
                      name: el.name,
                      city: el.city,
                      iataCode: el.iataCode,
                      country: el.country
                    });
                    return;
                  }
                }
                listArr.push({
                  sort: el.sort,
                  list: [
                    {
                      code: el.code,
                      name: el.name,
                      city: el.city,
                      iataCode: el.iataCode,
                      country: el.country
                    }
                  ]
                });
              });
              if (document.body.clientWidth > 640) {
                listArr.map(item => {
                  if (item.list.length % 2 != 0) {
                    item.list.push([]);
                  }
                });
              }
              this.newAirportList = listArr;
            }
          });
      }
    },
    toTerminal(item) {
      this.$router.push({
        path: "/terminal",
        query: {
          airportCode: item.code,
          airportName: item.name,
          airportCountry: item.country,
          airportCity: item.city,
          iataCode: item.iataCode
        }
      });
    }
  },
  computed: {
    airportTotal() {
      const num = this.airportList.length;
      if (num > 1) {
        return num + " Airports";
      } else {
        return num + " Airport";
      }
    }
  },
  watch: {
    search(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.showRequired = false;
      }
    }
  }
};
</script>

<style scoped>
.disable {
  pointer-events: none;
}

.banner {
  width: 100%;
  height: 600px;
  background: url("../assets/images/mainpage-hero-image@2x.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  left: 0;
  top: 1px;
}

.search-wrap {
  width: 500px;
  height: 300px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.6);
}

.search-inner {
  width: 344px;
  margin: 60px auto;
}

.search-title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.search-title .tip {
  font-size: 14px;
  font-weight: normal;
}

.search-input {
  height: 50px;
  border: 1px #333333 solid;
  border-radius: 4px;
  background: #fff;
  margin: 20px 0;
  position: relative;
  overflow: hidden;
}

.search-inner .required {
  border: 2px #910000 solid;
}

.search-input img {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 15px;
  left: 10px;
}

.search-input input {
  width: 240px;
  height: 100%;
  padding: 0 40px;
  border: none;
  outline: none;
  color: #7b8090;
  font-size: 16px;
}

.search-btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  background: #910000;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.airport-wrap {
  width: 80%;
  margin: 0 auto;
}

.airport-wrap .loading {
  width: 90px;
  margin: 100px auto;
}

.airport-wrap .loading img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.airport-wrap .loading p {
  height: 23px;
  line-height: 23px;
  margin-top: 10px;
  font-size: 17px;
  color: #555555;
  text-align: center;
}

.airport-wrap .noData {
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  color: #2d354d;
}

.airport-wrap .hasData {
  padding-bottom: 80px;
}

.airport-wrap .hasData .num {
  height: 100px;
  line-height: 100px;
  font-family: "SemiBold";
  font-size: 30px;
  color: #2d354d;
  border-bottom: 1px #ccc solid;
}

.airport-wrap .hasData .sort {
  font-family: "SemiBold";
  font-size: 14px;
  color: #7b8090;
  margin-top: 30px;
}

.airport-list .zimu {
  font-family: "SemiBold";
  font-size: 18px;
  color: #2d354d;
  padding: 30px 0;
  border-bottom: 1px #ccc solid;
}

.airport-list li {
  float: left;
  width: 50%;
  height: 97px;
  border-bottom: 1px #ccc solid;
}

.airport-list li div {
  width: 92%;
  height: 46px;
  cursor: pointer;
  margin: 10px;
  padding: 15px 4%;
}

.airport-list li:nth-child(2n) > div.borderLeft {
  border-left: 1px #ccc solid;
}

.airport-list li div:hover {
  background: #f0f0f0;
}

.airport-list .name {
  font-family: "SemiBold";
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.airport-list .addr {
  font-family: "Regular";
  font-size: 14px;
  color: #7b8090;
}

@media screen and (max-width: 1000px) {
  .airport-wrap {
    width: 90%;
  }
}

@media screen and (max-width: 640px) {
  .banner {
    height: 450px;
  }

  .search-wrap {
    width: 96%;
    height: 200px;
  }

  .search-inner {
    width: 90%;
    margin: 20px auto;
  }

  .search-input {
    margin: 15px 0;
  }

  .airport-wrap .hasData .sort,
  .airport-list .zimu {
    display: none;
  }

  .airport-list ul {
    border-bottom: none;
    padding: 0;
  }

  .airport-list li {
    width: 100%;
    height: 77px;
  }

  .airport-list li div {
    height: 36px;
    padding: 10px 0;
  }

  .airport-list li:nth-child(2n) > div {
    border-left: none;
  }

  .airport-list li div:hover {
    background: none;
  }

  .airport-wrap .hasData .num {
    height: 70px;
    line-height: 70px;
    font-size: 16px;
  }

  .airport-list .name {
    font-size: 12px;
  }

  .airport-list .addr {
    font-size: 12px;
  }

  .airport-wrap .noData {
    font-size: 16px;
  }

  .search-title {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }

  .search-title .tip {
    font-size: 12px;
    font-weight: normal;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/Airport.vue